module.exports = (__webpack_require__(14))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor_library
// module id = 76
// module chunks = 0